import moment from 'moment';
import { generateRecurringWeekdayBlocks } from '../dateHelpers';

const durationRegex = /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// TODO: Consider refactoring or removing this whole helper, based on updated business needs and actual usage,
// removing all unused cases and deprecated configurations. Reconsider the need of momentjs usage
// and also enforce actual ISO 8601 pattern standards.

export function parseISO8601Pattern(pattern: string) {
  const parts = pattern.split('/');
  let repetitions = parts[0] ?? '';
  let startDate: any = parts[1];
  let duration = parts[2];
  let endDate: any = parts[3];

  const firstSegment = (repetitions || '').trim();
  const fridayOnly = firstSegment.toUpperCase() === 'F';
  // F/ must not use the W… branch; WH/ and W/ continue to use it
  const weekendsOnly = !fridayOnly && (repetitions || '').toUpperCase().startsWith('W');

  // TODO: Review implementation. Setting this custom ad-hoc way to handle a specific subset of 'weekendsOnly' case,
  // targeted to 'Holidays' season, where business wants to enable also Fridays as available days for shipping.
  const weekendsOnlyHolidays = (repetitions || '').toUpperCase().charAt(1) === 'H';

  repetitions = (repetitions || '').replace(/W/i, '').replace('R', '').replace('H', '');

  let rep = repetitions ? parseInt(repetitions, 10) : 1;

  if (fridayOnly && !startDate && !duration && !endDate) {
    startDate = moment().startOf('year') as any;
    endDate = moment().add(1, 'year') as any;
  }

  // Handling 'W/' case
  if (weekendsOnly && !startDate && !duration && !endDate) {
    startDate = moment().startOf('year') as any;
    endDate = moment().add(1, 'year') as any;
  }

  if (!startDate && !duration && endDate) {
    startDate = moment().format() as any;
  }

  if (repetitions && moment(repetitions, moment.ISO_8601, true).isValid()) {
    startDate = repetitions as any;
    rep = 1;
  }

  if (startDate && typeof startDate === 'string' && startDate.startsWith('P')) {
    duration = startDate;
    startDate = null;
  }

  let period: RegExpExecArray | null | undefined;
  if (duration && duration.startsWith('P')) {
    period = durationRegex.exec(duration);
  }

  startDate = startDate ? moment(startDate) : moment();

  if (!endDate && period) {
    endDate = startDate.clone().add({
      years: Number(period[1] || 0),
      months: Number(period[2] || 0),
      weeks: Number(period[3] || 0),
      days: Number(period[4] || 0),
      hours: Number(period[5] || 0),
      minutes: Number(period[6] || 0),
      seconds: Number(period[7] || 0),
    });
  }

  if (!startDate && duration && endDate) {
    startDate = moment(endDate).subtract({
      years: Number(period![1] || 0),
      months: Number(period![2] || 0),
      weeks: Number(period![3] || 0),
      days: Number(period![4] || 0),
      hours: Number(period![5] || 0),
      minutes: Number(period![6] || 0),
      seconds: Number(period![7] || 0),
    });
  }

  endDate = endDate ? moment(endDate) : startDate.clone().add(1, 'year');

  let result: Array<{ startDate: string; endDate: string }>;
  if (fridayOnly) {
    result = generateRecurringWeekdayBlocks(
      startDate.format('YYYY-MM-DD'),
      endDate.format('YYYY-MM-DD'),
      [5]
    );
  } else if (weekendsOnly) {
    if (rep === 1) {
      const blocked = weekendsOnlyHolidays ? [6, 0] : [5, 6, 0];
      result = generateRecurringWeekdayBlocks(
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
        blocked
      );
    } else {
      result = calculateWeekendsOnlyLegacy(
        startDate,
        endDate,
        rep,
        weekendsOnlyHolidays
      );
    }
  } else {
    result = [
      { startDate: startDate.format('YYYY-MM-DD'), endDate: endDate.format('YYYY-MM-DD') },
    ];
  }

  if (result.length === 1) {
    return result[0];
  }

  return result;
}

function calculateWeekendsOnlyLegacy(
  startDate: moment.Moment,
  endDate: moment.Moment,
  rep: number,
  holidays: boolean
) {
  const result: Array<{ startDate: string; endDate: string }> = [];
  const current = startDate.clone();

  while (current.isSameOrBefore(endDate, 'day')) {
    if (
      weekdays[current.day()] === (holidays ? 'Saturday' : 'Friday') &&
      (rep === 1 || result.length < rep)
    ) {
      result.push({
        startDate: current.format('YYYY-MM-DD'),
        endDate: current
          .clone()
          .add(holidays ? 1 : 2, 'days')
          .format('YYYY-MM-DD'), // Adding 2 days to cover Friday to Sunday
      });
      current.add(holidays ? 1 : 2, 'days'); // Skip Saturday and Sunday after adding the weekend
    } else {
      current.add(1, 'days');
    }
  }
  return result;
}
